import { render, staticRenderFns } from "./Fechamento.vue?vue&type=template&id=5b78aaf2&"
import script from "./Fechamento.vue?vue&type=script&lang=js&"
export * from "./Fechamento.vue?vue&type=script&lang=js&"
import style0 from "./Fechamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports